import {
  SET_LOGGED_IN,
  SET_APP_READY,
  SET_APP_ERROR,
  SET_USER_STATUS,
  SET_TENNIS_ID,
  SET_STORED_RAY_ID,
  ACCOUNT_DETAILS_REQUESTED,
  ACCOUNT_DETAILS_COMPLETED,
  ACCOUNT_DETAILS_FAILED,
  UPDATE_ACCOUNT_DETAILS_REQUESTED,
  UPDATE_ACCOUNT_DETAILS_COMPLETED,
  UPDATE_ACCOUNT_DETAILS_FAILED,
  ACCOUNT_EMAIL_REQUESTED,
  ACCOUNT_EMAIL_COMPLETED,
  ACCOUNT_EMAIL_FAILED,
  ACCOUNT_ACTIVATION_REQUESTED,
  ACCOUNT_ACTIVATION_COMPLETED,
  ACCOUNT_ACTIVATION_FAILED,
  RESET_USER,
  FEATURES_CONFIG_REQUESTED,
  FEATURES_CONFIG_FAILED,
  FEATURES_CONFIG_COMPLETED,
  UPDATE_ACCOUNT_AVATAR_REQUESTED,
  UPDATE_ACCOUNT_AVATAR_COMPLETED,
  UPDATE_ACCOUNT_AVATAR_FAILED,
} from 'actions/user-actions'
import { ActionType } from 'typesafe-actions'
import * as actions from 'actions/user-actions'
import {
  AccountDetails,
  AccountRegistrationDetails,
  FeaturesConfig,
  UserStatus,
} from 'types/global'

type UserAction = ActionType<typeof actions>

export type State = Readonly<{
  isLoggedIn: boolean
  appReady: boolean
  appError: Error | null
  userStatus: null | UserStatus
  tennisId: string
  emailAddress: string
  emailAddressLoading: boolean
  emailAddressError: boolean
  accountDetails: AccountRegistrationDetails | AccountDetails | null
  accountDetailsLoading: boolean
  accountDetailsUpdating: boolean
  accountDetailsError: Error | null
  activationInProgress: boolean
  activationError: Error | null
  featuresConfig: FeaturesConfig | null
  featuresConfigLoading: boolean
  featuresConfigError: Error | null
  storedRayId: string
  accountAvatarLoading: boolean
}>

export const initialState: State = {
  isLoggedIn: false,
  appReady: false,
  appError: null,
  userStatus: null,
  tennisId: '',
  emailAddress: '',
  emailAddressLoading: false,
  emailAddressError: false,
  accountDetails: null,
  accountDetailsLoading: false,
  accountDetailsUpdating: false,
  accountDetailsError: null,
  activationInProgress: false,
  activationError: null,
  featuresConfig: null,
  featuresConfigLoading: true,
  featuresConfigError: null,
  storedRayId: '',
  accountAvatarLoading: false,
}
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: UserAction): State => {
  switch (action.type) {
    case RESET_USER:
      return { ...initialState, appReady: true }
    case SET_LOGGED_IN:
      return { ...state, isLoggedIn: true }
    case SET_APP_READY:
      return { ...state, appError: null, appReady: true }
    case SET_APP_ERROR:
      return { ...state, appError: action.payload }
    case SET_USER_STATUS:
      return { ...state, userStatus: action.payload }
    case ACCOUNT_ACTIVATION_REQUESTED:
      return { ...state, activationInProgress: true, activationError: null }
    case ACCOUNT_ACTIVATION_COMPLETED:
      return {
        ...state,
        activationInProgress: true,
        activationError: null,
        userStatus: UserStatus.ACTIVE,
      }
    case ACCOUNT_ACTIVATION_FAILED:
      return { ...state, activationInProgress: false, activationError: action.payload }
    case ACCOUNT_DETAILS_REQUESTED:
      return { ...state, accountDetailsLoading: true, accountDetailsError: null }
    case ACCOUNT_DETAILS_COMPLETED:
      return {
        ...state,
        accountDetailsLoading: false,
        accountDetailsError: null,
        accountDetails: action.payload,
      }
    case ACCOUNT_DETAILS_FAILED:
      return { ...state, accountDetailsLoading: false, accountDetailsError: action.payload }
    case UPDATE_ACCOUNT_DETAILS_REQUESTED:
      return { ...state, accountDetailsUpdating: true, accountDetailsError: null }
    case UPDATE_ACCOUNT_DETAILS_COMPLETED:
      return {
        ...state,
        accountDetailsUpdating: false,
        accountDetailsError: null,
        accountDetails: {
          ...(state.accountDetails ?? ({} as AccountDetails)),
          ...action.payload,
        },
      }
    case UPDATE_ACCOUNT_DETAILS_FAILED:
      return { ...state, accountDetailsUpdating: false, accountDetailsError: action.payload }
    case UPDATE_ACCOUNT_AVATAR_REQUESTED:
      return { ...state, accountAvatarLoading: true }
    case UPDATE_ACCOUNT_AVATAR_COMPLETED:
      return {
        ...state,
        accountAvatarLoading: false,
        accountDetails: {
          ...(state.accountDetails ?? ({} as AccountDetails)),
          biographicalInformation: {
            ...(((state.accountDetails) as AccountDetails)?.biographicalInformation ?? {}),
            avatarUrl: action.payload,
          }
        },
      }
    case UPDATE_ACCOUNT_AVATAR_FAILED:
      return { ...state, accountAvatarLoading: false, accountDetailsError: action.payload }
    case FEATURES_CONFIG_REQUESTED:
      return { ...state, featuresConfigLoading: true, featuresConfigError: null }
    case FEATURES_CONFIG_COMPLETED:
      return {
        ...state,
        featuresConfigLoading: false,
        featuresConfigError: null,
        featuresConfig: action.payload,
      }
    case FEATURES_CONFIG_FAILED:
      return { ...state, featuresConfigLoading: false, featuresConfigError: action.payload }
    case SET_TENNIS_ID:
      return { ...state, tennisId: action.payload }
    case SET_STORED_RAY_ID:
      return { ...state, storedRayId: action.payload }
    case ACCOUNT_EMAIL_REQUESTED:
      return { ...state, emailAddressLoading: true }
    case ACCOUNT_EMAIL_COMPLETED:
      return { ...state, emailAddressLoading: false, emailAddress: action.payload }
    case ACCOUNT_EMAIL_FAILED:
      return { ...state, emailAddressLoading: false, emailAddressError: true }
    default:
      return state
  }
}
